const CryptoJS = require("crypto-js");

const key = "74sDBKZ4s5Hnu6TZZl6VOoWCY5GX7ae6N4CTGm";

export const encrypt = (text) => {
  return CryptoJS.AES.encrypt(text, key).toString();
};
